"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var elog = require("@reverbdotcom/commons/dist/elog");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var bind_1 = require("../../bind");
var COMPONENT_NAME = 'FuDeclineFeedbackllBleedHeading';
var declineFeedbackGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  mutation DeclineFeedbackMutation(\n    $input: Input_core_apimessages_DeclineFeedbackRequest\n  ) {\n    declineFeedbackRequest(input: $input) {\n      orderUuid\n    }\n  }\n"], ["\n  mutation DeclineFeedbackMutation(\n    $input: Input_core_apimessages_DeclineFeedbackRequest\n  ) {\n    declineFeedbackRequest(input: $input) {\n      orderUuid\n    }\n  }\n"])));
var declineFeedbackMutation = react_apollo_1.graphql(declineFeedbackGQL, {
    name: 'declineFeedbackMutation',
});
var DeclineFeedback = /** @class */ (function (_super) {
    tslib_1.__extends(DeclineFeedback, _super);
    function DeclineFeedback() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeclineFeedback.prototype.onSuccess = function () {
        this.props.onSuccess();
    };
    DeclineFeedback.prototype.onError = function (e) {
        elog.error("DeclineFeedbackError (" + COMPONENT_NAME + ")", {}, e);
    };
    DeclineFeedback.prototype.declineFeedback = function (event) {
        event.preventDefault();
        return this.props.declineFeedbackMutation({
            variables: {
                input: {
                    orderUuid: this.props.orderUuid,
                },
            },
        }).then(this.onSuccess, this.onError);
    };
    DeclineFeedback.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("span", { "data-decline-feedback": true, "data-tooltip-text": I18n.t('discovery.declineFeedback.tooltip') },
                React.createElement("a", { onClick: this.declineFeedback },
                    React.createElement("span", { className: "fa fa-times" })))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], DeclineFeedback.prototype, "onSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], DeclineFeedback.prototype, "onError", null);
    tslib_1.__decorate([
        bind_1.default
    ], DeclineFeedback.prototype, "declineFeedback", null);
    return DeclineFeedback;
}(React.Component));
exports.DeclineFeedback = DeclineFeedback;
exports.default = react_apollo_1.compose(declineFeedbackMutation)(DeclineFeedback);
var templateObject_1;
//# sourceMappingURL=decline_feedback.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/feedbacks/decline_feedback.js
// module id = Cp2H
// module chunks = 20 21